module.exports = __webpack_public_path__ + "img/8.36f1e648.png";